module.exports = __webpack_public_path__ + "img/ms_teams.5a26253d.svg";